import { render, staticRenderFns } from "./VWrapper.vue?vue&type=template&id=300e587e"
import script from "./VWrapper.vue?vue&type=script&lang=ts"
export * from "./VWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports